import {
  Avatar,
  Box,
  Button,
  Flex,
  Input,
  Progress,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useMemo, useState } from "react";
import { CgTrash } from "react-icons/cg";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import { CloseIcon } from "@chakra-ui/icons";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function TableFriends(props) {
  const {
    columnsData,
    tableData,
    title,
    pagination,
    nextPage,
    prevPage,
    firstPage,
    lastPage,
    goToPage,
    limitPage,
    type,
    onClickAction,
    onDeleteFriend,
  } = props;

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);
  const [showDialog, setShowDialog] = useState(false);
  const [selectedId, setSelectedId] = useState();

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } =
    tableInstance;

  const textColor = useColorModeValue("navy.700", "white");
  const textColorSecondary = useColorModeValue("secondaryGray.600", "white");

  const onOpenDialog = (id) => {
    setShowDialog(true);
    setSelectedId(id);
  };

  const onCloseDialog = () => {
    setShowDialog(false);
    setSelectedId(null);
  };

  const onConfirmDelete = () => {
    onDeleteFriend(selectedId);
    setShowDialog(false);
    setSelectedId(null);
  };

  return (
    <>
      <Flex
        direction="column"
        w={{ md: "100%", lg: "80%" }}
        overflowX={{ sm: "scroll", lg: "hidden" }}
      >
        <Box
          sx={{
            position: "-webkit-sticky",
            /* Safari */ position: "sticky",
            top: "0",
          }}
        >
          <Text
            fontWeight="bold"
            fontSize={{ sm: "md", md: "lg", lg: "xl" }}
            color="green"
          >
            {title}
          </Text>
        </Box>
        <Table
          {...getTableProps()}
          id="tableFriend"
          variant="striped"
          colorScheme="brand"
          color="gray.500"
        >
          <Thead bgColor="#D5DDFC">
            {headerGroups.map((headerGroup, index) => (
              <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
                {headerGroup.headers.map((column, index) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    pe="10px"
                    key={index}
                  >
                    <Flex
                      fontSize={{ sm: "12px", lg: "14px" }}
                      color="gray.400"
                      alignItems="center"
                      borderTopRadius={5}
                      paddingY={1}
                      bgColor="#D5DDFC"
                    >
                      <Text
                        textAlign="center"
                        fontWeight="bold"
                        color="#000"
                        textTransform="uppercase"
                        fontSize={{ sm: "xs", md: "sm" }}
                      >
                        {column.render("Header")}
                      </Text>
                    </Flex>
                  </Th>
                ))}
              </Tr>
            ))}
          </Thead>

          <Tbody {...getTableBodyProps()}>
            {page.map((row, index) => {
              prepareRow(row);
              return (
                <Tr {...row.getRowProps()} key={index}>
                  {row.cells.map((cell, index) => {
                    let data = "";
                    if (cell.column.Header === "Display name") {
                      data = (
                        <Text
                          color={"black"}
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          overflow="hidden"
                          whiteSpace="nowrap"
                          maxWidth={150}
                          width={{ sm: "80px", md: "150px" }}
                          textOverflow="ellipsis"
                        >
                          {cell.value}
                        </Text>
                      );
                    } else if (cell.column.Header === "Birth date") {
                      data = (
                        <Text
                          color={"black"}
                          fontSize={{ sm: "xs", md: "sm" }}
                          fontWeight="500"
                          overflow="hidden"
                          whiteSpace="nowrap"
                          maxWidth={200}
                          textOverflow="ellipsis"
                        >
                          {cell.value
                            ? moment(cell.value).format("DD MMM YYYY")
                            : "-"}
                        </Text>
                      );
                    } else if (
                      cell.column.Header === "Action" &&
                      title === "Friends Request"
                    ) {
                      data = (
                        <Flex flexDirection="row" gap={2}>
                          <Button
                            bgColor="#1877f2"
                            onClick={() =>
                              onClickAction({ id: cell.value, value: 1 })
                            }
                            color="white"
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="bold"
                            borderRadius="5px"
                            px="10px"
                            py="5px"
                          >
                            Accept
                          </Button>
                          <Button
                            bgColor="red"
                            onClick={() =>
                              onClickAction({ id: cell.value, value: 2 })
                            }
                            color="white"
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="bold"
                            borderRadius="5px"
                            px="10px"
                            py="5px"
                          >
                            Decline
                          </Button>
                        </Flex>
                      );
                    } else if (cell.column.Header === "Action") {
                      data = (
                        <Flex flexDirection="row" gap={2}>
                          <Button
                            bgColor="#68349A"
                            onClick={() =>
                              window.location.assign(
                                `/dashboard/friend-list/${
                                  type === "friend" ? "friend" : "colleague"
                                }/${cell.value}`
                              )
                            }
                            color="white"
                            fontSize={{ sm: "xs", md: "sm" }}
                            fontWeight="bold"
                            borderRadius="5px"
                            px="15px"
                            py="5px"
                          >
                            View
                          </Button>
                          <Flex
                            cursor="pointer"
                            border="2px solid #68349A"
                            borderRadius={5}
                            paddingY="5px"
                            alignItems="center"
                            justifyContent="center"
                            width="25px"
                            onClick={() =>
                              onOpenDialog(
                                row.original?.friend_id ?? row.original.id
                              )
                            }
                          >
                            <CgTrash color="#68349A" />
                          </Flex>
                        </Flex>
                      );
                    } else {
                      data = (
                        <Text
                          color={"black"}
                          fontSize={{ sm: "sm", md: "md" }}
                          fontWeight="500"
                        >
                          {cell.value ?? "-"}
                        </Text>
                      );
                    }

                    return (
                      <Td
                        {...cell.getCellProps()}
                        key={index}
                        fontSize={{ sm: "14px" }}
                        minW={{ sm: "80px", md: "200px", lg: "auto" }}
                        width={{ sm: "80px", md: "150px" }}
                      >
                        {data}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
        <Flex
          direction="row"
          gap={2}
          alignItems="center"
          justifyContent="center"
          w={{ sm: "max-content", lg: "100%" }}
        >
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"white"}
            color="black"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => firstPage(type)}
            disabled={pagination.page === 1}
          >
            {"<<"}
          </Button>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"white"}
            color="black"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => prevPage(type)}
            disabled={pagination.page === 1}
          >
            {"<"}
          </Button>
          <Flex
            borderWidth={1}
            bg={"white"}
            borderRadius="5px"
            px="10px"
            py="5px"
            gap={2}
          >
            <Text color="#000" fontSize="md">
              Page{" "}
            </Text>
            <Input
              variant="search"
              fontSize={{ sm: "xs", md: "sm" }}
              bg={"white"}
              color={"black"}
              w={10}
              fontWeight="500"
              borderRadius={5}
              textAlign="center"
              placeholder={pagination.page}
              value={pagination.page}
              onChange={(e) => {
                const page = e.target.value;
                goToPage(type, page);
              }}
            />
            <Text color="#000" fontSize="md">
              {" "}
              / {pagination.max}
            </Text>
          </Flex>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"white"}
            color="black"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => nextPage(type)}
            disabled={pagination.page === pagination.max}
          >
            {">"}
          </Button>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"white"}
            color="black"
            fontSize={{ sm: "xs", md: "sm" }}
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => lastPage(type)}
            disabled={pagination.page === pagination.max}
          >
            {">>"}
          </Button>
          <select
            style={{ padding: "5px 10px" }}
            value={pagination.limit}
            onChange={(e) => {
              limitPage(type, Number(e.target.value));
            }}
          >
            {[1, 5, 10, 20, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                Show {pageSize}
              </option>
            ))}
          </select>
          <Text fontSize={{ sm: "xs", md: "sm" }}>
            {pagination.limit > pagination.total
              ? pagination.total
              : pagination.limit}{" "}
            of {pagination.total}
          </Text>
        </Flex>
      </Flex>
      <BootstrapDialog
        onClose={onCloseDialog}
        aria-labelledby="customized-dialog-title"
        open={showDialog}
      >
        <DialogTitle
          sx={{ m: 0, p: 3, backgroundColor: "#D5DDFC" }}
          id="customized-dialog-title"
        ></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={onCloseDialog}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon width={3} />
        </IconButton>
        <DialogContent>
          <Flex
            flexDirection="column"
            wrap="wrap"
            maxWidth="100%"
            gap={1}
            alignItems="center"
            justifyContent="center"
          >
            <Text>
              Apakah kamu akan menghapus User ini dari daftar List saat ini?
            </Text>
          </Flex>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center" }}>
          <Button
            borderWidth={1}
            // borderColor="#1877f2"
            bg={"green"}
            color="white"
            fontSize="sm"
            fontWeight="bold"
            borderRadius="5px"
            px="10px"
            py="5px"
            onClick={() => onConfirmDelete()}
            // disabled={pagination.page === pagination.max}
          >
            Ya
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  );
}

export default TableFriends;

{
  /* <div className="flex items-center gap-2">
        <button
          className="border rounded p-1"
          onClick={() => table.firstPage()}
          disabled={!table.getCanPreviousPage()}
        >
          {'<<'}
        </button>
        <button
          className="border rounded p-1"
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          {'<'}
        </button>
        <button
          className="border rounded p-1"
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          {'>'}
        </button>
        <button
          className="border rounded p-1"
          onClick={() => table.lastPage()}
          disabled={!table.getCanNextPage()}
        >
          {'>>'}
        </button>
        <span className="flex items-center gap-1">
          <div>Page</div>
          <strong>
            {table.getState().pagination.pageIndex + 1} of{' '}
            {table.getPageCount().toLocaleString()}
          </strong>
        </span>
        <span className="flex items-center gap-1">
          | Go to page:
          <input
            type="number"
            defaultValue={table.getState().pagination.pageIndex + 1}
            onChange={e => {
              const page = e.target.value ? Number(e.target.value) - 1 : 0
              table.setPageIndex(page)
            }}
            className="border p-1 rounded w-16"
          />
        </span>
        <select
          value={table.getState().pagination.pageSize}
          onChange={e => {
            table.setPageSize(Number(e.target.value))
          }}
        >
          {[10, 20, 30, 40, 50].map(pageSize => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select>
      </div> */
}
